export enum DisruptionIconNameEnum {
  disruptionProtection = "disruptionProtection",
  disruptionHowItWorksDialogInfoLineOne = "disruptionHowItWorksDialogInfoLineOne",
  disruptionHowItWorksDialogInfoLineTwo = "disruptionHowItWorksDialogInfoLineTwo",
  disruptionHowItWorksDialogInfoLineThree = "disruptionHowItWorksDialogInfoLineThree",
  disruptionHowItWorksDialogBulletOne = "disruptionHowItWorksDialogBulletOne",
  disruptionHowItWorksDialogBulletTwo = "disruptionHowItWorksDialogBulletTwo",
  disruptionHowItWorksDialogBulletThree = "disruptionHowItWorksDialogBulletThree",
  disruptionBulletPointOne = "disruptionBulletPointOne",
  disruptionBulletPointTwo = "disruptionBulletPointTwo",
  disruptionBulletPointThree = "disruptionBulletPointThree",
  disruptionConfirmationIcon = "disruptionConfirmationIcon",
  disruptionFilterCheckboxIcon = "disruptionFilterCheckboxIcon",
  /** Icon for "No thanks" / declined option; tenants can override (e.g. red circle-X). */
  disruptionDeclined = "disruptionDeclined",
  disruptionFintechCheckmarkBulletPoint = "disruptionFintechCheckmarkBulletPoint",
}
